import Historicidad from './Historicidad';

export default function HistoricidadPage() {
  return <Historicidad />;
}






